/* ============================================================================
   Der HandyRetter — Design-System JS (Redesign 2026)
   Mobile-Funnel-Verhalten: A5 (Produkt-Kaufleiste), F10 (Warenkorb-Kasse),
   F5 (suchgefuehrter Hero-CTA). Rein additiv, defensiv (bricht nie das Theme):
   alles feature-detected, no-ops wenn Elemente fehlen.
   ============================================================================ */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  /* ---- F5: suchgefuehrt — CTA fokussiert das Suchfeld -----------------------
     Greift bei [data-hr-focus-search], .hr-search-cta und reinen /search-Links
     (z. B. Hero "Reparatur starten"). Bevorzugt das Suchfeld im SELBEN Formular
     (Hero-Suchfeld), sonst das Header-Suchfeld (auf Mobile vorher aufklappen).
     Hat der Nutzer im Hero schon getippt, laeuft die normale Suche (kein Abfangen). */
  function openAndFocus(input) {
    if (!input) { return; }
    if (input.classList.contains('search-bar__input') && !isVisible(input)) {
      var toggle = document.querySelector('[data-action="toggle-search"]');
      if (toggle) { toggle.click(); }
    }
    window.setTimeout(function () {
      try { input.focus({ preventScroll: false }); } catch (e) { input.focus(); }
    }, 80);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest
      ? e.target.closest('[data-hr-focus-search], .hr-search-cta, a[href$="/search"], a[href$="/search/"]')
      : null;
    if (!t) { return; }
    var form = t.closest ? t.closest('form') : null;
    var input = (form && (form.querySelector('.hr-hero__search-input') || form.querySelector('input[name="q"]')))
             || document.querySelector('.hr-hero__search-input')
             || document.querySelector('.search-bar__input');
    if (!input) { return; }
    var isSubmit = (t.getAttribute && t.getAttribute('type') === 'submit') || t.type === 'submit';
    if (isSubmit && form && input.value && input.value.trim() !== '') { return; }  /* getippt -> suchen lassen */
    e.preventDefault();
    openAndFocus(input);
  });

  /* ---- A5: mitlaufende Kaufleiste auf der Produktseite ----------------------
     - Beobachtet den ECHTEN Haupt-Absende-Button dieses Themes:
       button.product-form__add-button (type=submit, OHNE name="add") im
       <product-form> / form[action*="/cart/add"]. Verlaesst er das Sichtfeld
       nach OBEN (boundingRect.bottom < 0, d. h. man hat daran vorbeigescrollt),
       wird die Leiste eingeblendet; ist er wieder sichtbar, verschwindet sie.
       Beim Laden ausgeblendet.
     - Der Leisten-Button loest exakt den nativen Add-to-Cart aus (mainBtn.click),
       damit Varianten-Logik UND Warenkorb-Drawer identisch zum Hauptbutton sind.
     - Preis live aus der gewaehlten Variante; aktualisiert bei Variantenwechsel.
     - Ist ein Drawer/Warenkorb offen, bleibt die Leiste verborgen (kein Stapeln).
     - Nur Mobil: am Desktop ist die Kaufbox bereits sticky (.card--sticky),
       die Leiste wird dort per CSS ausgeblendet. */
  function buildProductBuyBar() {
    if (!document.body.classList.contains('template-product')) { return; }

    // Den ersten SICHTBAREN Haupt-Button nehmen (Quick-View liegt in <template>
    // und ist inert / nicht sichtbar) — KEIN [name="add"] in diesem Theme.
    function findMainAddBtn() {
      var btns = document.querySelectorAll('.product-form__add-button');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.offsetParent !== null || (b.getClientRects && b.getClientRects().length)) { return b; }
      }
      return btns[0] || null;
    }
    var addBtn = findMainAddBtn();
    if (!addBtn) { return; }
    var mainForm = addBtn.form || (addBtn.closest ? addBtn.closest('form') : null);

    var LABEL = 'Zum Warenkorb';

    function currentPrice() {
      var p = document.querySelector('.product-form__info-list .price-list .price:not(.price--compare)')
           || document.querySelector('.price-list .price:not(.price--compare)')
           || document.querySelector('.price-list .price');
      return p ? p.textContent.trim() : '';
    }

    var bar = document.createElement('div');
    bar.className = 'hr-buybar hr-buybar--product';
    bar.setAttribute('aria-hidden', 'true');

    var price = document.createElement('span');
    price.className = 'hr-buybar__price';
    price.textContent = currentPrice();

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'hr-buybar__cta button button--primary';
    cta.textContent = LABEL;
    cta.addEventListener('click', function () {
      if (addBtn.disabled) { return; }
      // Nativen Add-to-Cart wiederverwenden: echten .product-form__add-button ausloesen.
      addBtn.click();
    });

    bar.appendChild(price);
    bar.appendChild(cta);
    document.body.appendChild(bar);
    document.body.classList.add('hr-has-buybar');

    var belowMain = false;   // Hauptbutton nach oben aus dem Sichtfeld gescrollt?
    var drawerOpen = false;  // Warenkorb-/Menue-Drawer offen?

    function apply() {
      var show = belowMain && !drawerOpen;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('hr-buybar-visible', show);
    }

    // Preis + Verfuegbarkeit synchron halten (Variantenwechsel)
    var host = document.querySelector('.product-form__info-content')
            || document.querySelector('.price-list');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        price.textContent = currentPrice();
        var soldOut = !!addBtn.disabled;
        cta.disabled = soldOut;
        cta.textContent = soldOut ? ((addBtn.textContent || '').trim() || 'Nicht verfügbar') : LABEL;
      }).observe(host, { childList: true, subtree: true, characterData: true });
    }

    // Sichtbarkeit: einblenden erst NACH dem Vorbeiscrollen am Hauptbutton
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          belowMain = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          apply();
        });
      }, { threshold: 0 }).observe(addBtn);
    } else {
      belowMain = true; apply();
    }

    // Drawer/Warenkorb offen -> Leiste ausblenden (kein Stapeln)
    function anyDrawerOpen() {
      var sel = '#mini-cart[aria-hidden="false"], .mini-cart[aria-hidden="false"], .mini-cart.is-open, '
              + '.drawer--cart[aria-hidden="false"], .cart-drawer.is-open, cart-drawer[open], .drawer.is-open';
      if (document.querySelector(sel)) { return true; }
      var b = document.body.classList, h = document.documentElement.classList;
      return b.contains('js-drawer-open') || b.contains('drawer-open') || h.contains('drawer-open');
    }
    if ('MutationObserver' in window) {
      var raf = null;
      var recalc = function () {
        raf = null;
        var now = anyDrawerOpen();
        if (now !== drawerOpen) { drawerOpen = now; apply(); }
      };
      var schedule = function () { if (!raf) { raf = window.requestAnimationFrame(recalc); } };
      new MutationObserver(schedule).observe(document.body, {
        attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'], subtree: true
      });
      // Nach Klick auf unsere CTA der Drawer-Pruefung Vorrang geben
      cta.addEventListener('click', function () { window.setTimeout(schedule, 60); });
    }
  }

  /* ---- F10: Sticky-Kasse im Warenkorb -------------------------------------- */
  function buildCartBar() {
    if (!document.body.classList.contains('template-cart')) { return; }
    var checkoutBtn = document.querySelector('.cart-recap__checkout');
    if (!checkoutBtn) { return; }   // leerer Warenkorb -> kein Button -> keine Leiste

    var totalEl = document.querySelector('.cart-recap__price-line-price')
               || document.querySelector('.cart-recap__price-line');

    var bar = document.createElement('div');
    bar.className = 'hr-buybar hr-cartbar is-visible';

    var total = document.createElement('span');
    total.className = 'hr-buybar__price';
    function syncTotal() { if (totalEl) { total.textContent = 'Summe ' + totalEl.textContent.trim(); } }
    syncTotal();

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'hr-buybar__cta button button--primary';
    cta.textContent = 'Kasse';
    cta.addEventListener('click', function () { checkoutBtn.click(); });

    bar.appendChild(total);
    bar.appendChild(cta);
    document.body.appendChild(bar);
    document.body.classList.add('hr-has-cartbar');

    var recap = document.querySelector('.cart-recap');
    if (recap && 'MutationObserver' in window) {
      new MutationObserver(syncTotal).observe(recap, { childList: true, subtree: true, characterData: true });
    }
  }

  onReady(function () {
    try { buildProductBuyBar(); } catch (e) { /* defensiv: niemals das Theme brechen */ }
    try { buildCartBar(); } catch (e) { /* defensiv */ }
  });
})();
